import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { MassUploadDeleteButton } from "my-documents/components";
import { OcConfirmationDialog } from "oc/components";

interface Document {
  _id: string;
  filename: string;
  size: number;
  description: string;
  user: string;
}

interface MassUploadCollapseProps {
  row: {
    massUploadId?: string;
    documents?: Document[];
  };
  isNotExaminer: boolean;
  removeMassUpload: (row: any) => void;
  rowIndex?: number;
}

export const MassUploadCollapse: React.FC<MassUploadCollapseProps> = ({
  row,
  isNotExaminer,
  removeMassUpload,
  rowIndex,
}) => {
  const { t } = useTranslation();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const handleDialogCancel = () => {
    setShowConfirmDialog(false);
  };

  return (
    <>
      <OcConfirmationDialog
        showDialog={showConfirmDialog}
        onClose={() => {
          removeMassUpload(row);
        }}
        onCancel={handleDialogCancel}
        title={t("OC_DELETE_CONFIRM")}
        texts={[t("MY_DOCUMENTS_DELETE_MASS_UPLOAD_CONFIRM_INFO")]}
        okButtonText={t("OC_ALL_RIGHT")}
        cancelButtonText={t("OC_CANCEL")}
      />
      <Box padding="16px">
        <Box
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
        >
          <Box
            style={{
              color: "#4D4D4D",
              fontSize: "12px",
              letterSpacing: "0.4px",
              width: "128px",
              textAlign: "right",
              paddingRight: "16px",
            }}
          >
            {t("MY_DOCUMENTS_UPLOADED_FILES")}
          </Box>
          <Box>
            {row.documents && row.documents.length > 0 ? (
              row.documents.map((doc) => (
                <Box key={doc._id} style={{ marginBottom: "4px" }}>
                  {doc.filename}
                </Box>
              ))
            ) : (
              <Box>{t("MY_DOCUMENTS_NO_FILES")}</Box>
            )}
          </Box>
        </Box>
        {!isNotExaminer && (
          <Box>
            <Box height="18px" />
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <MassUploadDeleteButton
                setShowConfirmDialog={setShowConfirmDialog}
                id={`delete-${(rowIndex || 0) + 1}`}
              />
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default MassUploadCollapse;
